import { useMemo } from "react";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { useBillingStatus } from "@hooks/useBillingStatus";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useEntities } from "@hooks/useEntities";

export const LEGACY_PLUS_ENTITY_LIMIT = 5;

interface UseLegacyPlusEntityLimitResult {
    isAtLimit: boolean;
    entityCount: number;
    limit: number;
}

export function useLegacyPlusEntityLimit(): UseLegacyPlusEntityLimitResult {
    // Phase 3: legacy Plus customers (V1) are surfaced the entity-limit
    // modal whenever V3 routing is enabled — the modal's "Update plan"
    // CTA hits the workspace upgrade endpoint which drives the V1/V2 -> V3
    // swap.
    const { billingCatalogV3 } = useTypedFlags();
    const { isLegacyPlan, currentPlan } = useBillingStatus();
    const businessEntities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });

    return useMemo(() => {
        const entityCount = businessEntities.length;
        const isLegacyPlus =
            !!billingCatalogV3 &&
            isLegacyPlan &&
            currentPlan === FLAT_RATE_PLANS.PLUS;

        return {
            isAtLimit: isLegacyPlus && entityCount >= LEGACY_PLUS_ENTITY_LIMIT,
            entityCount,
            limit: LEGACY_PLUS_ENTITY_LIMIT,
        };
    }, [billingCatalogV3, isLegacyPlan, currentPlan, businessEntities.length]);
}
